export default {
	personalCenter: {
		vip_member: 'Thành viên VIP',
		vip: {
			level_label: 'Cấp VIP{level}', next_level: 'Cấp tiếp theo: VIP{level}',
			points_summary: 'Đã tích lũy {current} điểm, cần thêm {remaining} điểm để đạt VIP{level}',
			level_rewards: 'Thưởng cấp độ', reward_title: 'Thưởng VIP{level}', exclusive_rewards: 'Phần thưởng độc quyền', promotion_reward: 'Thưởng thăng cấp VIP{level}',
			previous_level: 'Cấp trước', next_level_button: 'Cấp tiếp theo',
			dragon_key: 'Chìa khóa Long Hồn ×{count}', battle_shard: 'Mảnh Chiến Văn ×{count}', forge_crystal: 'Tinh thể Rèn ×{count}',
			unlocked: 'Đã đạt VIP{level}, có thể nhận ngay.', locked: 'Chưa đạt VIP{level}.',
			claim: 'Nhận', claiming: 'Đang nhận...', claimed: 'Đã nhận', claim_success: 'Đã nhận thưởng VIP{level}', claim_failed: 'Nhận thưởng thất bại. Vui lòng thử lại sau.',
			points_label: 'Điểm', go_redeem: 'Đổi thưởng',
			experience_summary: 'EXP hiện tại: {current}; cần thêm {remaining} EXP để đạt VIP{level}',
			max_level: 'Chúc mừng, bạn đã đạt cấp tối đa', current_experience: 'EXP hiện tại: {current}'
		},
		title: 'Trung tâm cá nhân', my_exchange: 'Đổi thưởng của tôi', my_points: 'Điểm của tôi', lottery_records: 'Lịch sử quay thưởng', recharge_records: 'Lịch sử nạp',
		redeem_gift: 'Đổi quà', redeem_description: 'Nhập mã đổi thưởng để gửi phần thưởng đến nhân vật đã chọn.', redeem_code: 'Mã đổi thưởng', redeem_code_placeholder: 'Nhập mã đổi thưởng', redeeming: 'Đang đổi...', redeem_now: 'Đổi ngay', rebate_coupon: 'Phiếu hoàn {percent}%',
		points_details: 'Chi tiết điểm', exchange_time: 'Thời gian đổi', reward_content: 'Phần thưởng', status: 'Trạng thái', time: 'Thời gian', type: 'Loại', points_change: 'Thay đổi điểm', balance: 'Số dư', lottery_time: 'Thời gian quay', reward: 'Phần thưởng',
		order_id: 'Mã đơn hàng', payment_channel: 'Phương thức thanh toán', amount: 'Số tiền', server: 'Máy chủ', role: 'Nhân vật', payment_time: 'Thời gian thanh toán', copy: 'Sao chép',
		loading: 'Đang tải...', no_records: 'Không có dữ liệu phù hợp', no_content: 'Hiện chưa có nội dung để hiển thị.', previous: 'Trước', next: 'Tiếp', page_info: 'Trang {current} / {total}',
		source_recharge_reward: 'Thưởng nạp', source_official_activity: 'Sự kiện trang chủ', source_item_exchange: 'Đổi vật phẩm',
		exchange_success: 'Đổi thưởng thành công', exchange_failed: 'Đổi thưởng thất bại', enter_redeem_code: 'Vui lòng nhập mã đổi thưởng', exchange_retry: 'Đổi thưởng thất bại. Vui lòng thử lại sau.',
		copy_success: 'Đã sao chép', copy_failed: 'Sao chép thất bại', lottery_load_failed: 'Không thể tải lịch sử quay thưởng', lottery_load_retry: 'Không thể tải lịch sử quay thưởng. Vui lòng thử lại sau.',
		recharge_load_failed: 'Không thể tải lịch sử nạp', recharge_load_retry: 'Không thể tải lịch sử nạp. Vui lòng thử lại sau.', points_load_failed: 'Không thể tải lịch sử điểm', points_load_retry: 'Không thể tải lịch sử điểm. Vui lòng thử lại sau.',
		exchange_records_load_failed: 'Không thể tải lịch sử đổi thưởng', exchange_records_load_retry: 'Không thể tải lịch sử đổi thưởng. Vui lòng thử lại sau.'
	},
	member_popup: {
		title: 'Điểm thành viên đã tăng!',
		message: 'Lần nạp này bạn nhận được {points} điểm. Cần thêm {remaining} điểm để đạt VIP{nextLevel}.',
		progress: 'Điểm nạp tích lũy {current} / {target}',
		next: 'Cần thêm {remaining} điểm để đạt VIP{nextLevel}',
		suppress: 'Không nhắc lại trong 7 ngày',
		later: 'Để sau',
		rewards: 'Đến nhận thưởng',
		close: 'Đóng thông báo thành viên'
	},
	member_level: {
		title: 'Cấp thành viên',
		points_progress: 'Điểm nạp tích lũy',
		next_level: 'Cần thêm để lên VIP{level}:',
		points_unit: 'điểm',
		view_rewards: 'Xem thưởng cấp độ'
	},
	login_button_text: 'Đăng nhập',
	logining_button_text: 'Đăng nhập',
	account_input_text: 'Nhập email ràng buộc của bạn',
	password_input_text: 'Vui lòng nhập mật khẩu',
	other_login_methods_text: 'Phương thức đăng nhập khác',
	top_up_center_text: 'Trung tâm nạp tiền',
	benefit_text: 'Phú Lợi',
	sign_in_text: 'Đăng nhập',
	log_out_text: 'Đăng xuất',
	service_terms_text: 'Điều khoản dịch vụ',
	privacy_policy_text: 'Chính sách bảo mật',
	official_apk_download_text: 'APK chính thức',
	official_facebook_text: 'Facebook chính thức',
	recharge_instructions_text: 'Hướng dẫn nạp tiền',
	rebate_countdown_title: 'Hoàn Tiền Có Hạn Đang Diễn Ra',
	rebate_countdown_label: 'Đếm ngược',
	rebate_countdown_days: 'Ngày',
	rebate_countdown_hours: 'Giờ',
	rebate_countdown_minutes: 'Phút',
	rebate_countdown_seconds: 'Giây',
	log_in_game_account_text: 'đăng nhập vào tài khoản trò chơi của bạn',
	sign_in_lowercase_text: 'Đăng nhập',
	instructions_text: 'Hướng dẫn',
	confirm_text: 'Xác nhận',
	cancel_text: 'Hủy',
	switch_character_text: 'Chuyển đổi nhân vật',
	copy_successful_text: 'Sao chép thành công',
	claimed_text: 'Đã áp dụng',
	claim_success_text: 'Nhận thưởng thành công',
	claim_text: 'Áp dụng',
	claim_unmet_text: 'Chưa đủ điều kiện',
	contact_customer_service_text: 'Liên hệ CSKH',
	home_page_text: 'Trang chủ',
	payment_successful_text: 'Thanh toán thành công',
	purchase_confirm_text: 'Xác nhận mua hàng',
	payment_channels_text: 'Kênh thanh toán',
	payment_button_text: 'Thanh toán',
	original_price_text: 'Giá gốc',
	discounts_text: 'Giảm giá',
	earn_points_text: 'Nhận điểm',
	rebates_text: 'Hoàn tiền',
	amount_text: 'Số tiền',
	daily_rewards_text: 'รางวัลรายวัน',
	insufficient_points_text: 'Không đủ điểm',
	insufficient_lottery_count_text: 'Không đủ lượt quay',
	network_error_retry_text: 'Lỗi mạng, vui lòng thử lại sau.',
	score_lottery_text: 'Vòng quay điểm',
	score_lottery_entrance_error: 'Lỗi khi yêu cầu lối vào vòng quay điểm:',
	lottery_current_points_label: 'Điểm hiện tại:',
	lottery_points_recharge_tip: 'Có thể nhận điểm qua nạp tiền',
	lottery_spin_label: 'Vòng quay',
	lottery_rule_button: 'Chi tiết quy tắc',
	lottery_rule_popup_title: 'Quy tắc sự kiện',
	lottery_record_button: 'Xem lịch sử trúng thưởng',
	lottery_record_title: 'Lịch sử trúng thưởng',
	lottery_record_empty: 'Chưa có lịch sử',
	lottery_record_time: 'Thời gian',
	lottery_record_prize: 'Nội dung phần thưởng',
	lottery_daily_limit: 'Đã đạt giới hạn hôm nay',
	lottery_remaining_count: 'Số lượt còn lại {count}',
	lottery_draw_cost: '{cost} điểm/lần',
	lottery_init_data_error: 'Lỗi khi yêu cầu dữ liệu vòng quay điểm:',
	points_text: 'Cửa hàng điểm',
	winning_award_text: "Chúc mừng giải thưởng",
	receive_reward_tips_text: "The reward has been sent to your character's mailbox, please log in to your character to claim it!",
	hot_title_text: "HOT",
	limit_title_text: "LIMIT",
	limit_text: "Limit",
	sell_out_text: "Đã bán",
	copy_fail_text: "Sao chép thất bại",
	payment_type_text: "Kênh thanh toán",
	order_id_text: "Số đơn hàng",
	payment_time_text: "Thời gian thanh toán",
	copy_text: "Sao chép",
	amount_text: "Số tiền",
	game_server_text: "Máy chủ",
	game_role_text: "Nhân vật",
	orders_records_text: "Lịch sử nạp tiền",
	no_data_text: 'Không có dữ liệu',
	orders_tips_text: "Theo thiết lập hệ thống, phạm vi truy vấn lịch sử nạp tiền được giới hạn trong 30 ngày gần nhất",
	pointsDescribeText: '',
	pointsBalanceText: '',
	points_period_daily: 'Hôm nay',
	points_period_week: 'Tuần này',
	points_period_month: 'Tháng này',
	points_period_lifetime: 'Trọn đời',
	points_tag_mustBuy: 'Phải Mua',
	points_tag_selected: 'Được Chọn',
	points_tag_discount: 'Giảm Giá',
	points_tag_perk: 'Phúc Lợi',
	coupon: {
		discount_label: '返利券',
		title_html: '使用返利券購買後可額外獲得返利。',
		expired_text: '已失效',
		used_text: '已使用',
		countdown_prefix: '倒數',
		activity_button_text: 'Payback Coupon Draw'
	},
	pagination: {
		previous: "Trước",
		next: "Tiếp theo",
		page_info: "Trang {current} trên {total}"
	},
	// Support
	support_my_questions: 'Vấn đề của tôi',
	support_submit_issue: 'Gửi vấn đề',
	support_records_title: 'Lịch sử vấn đề của tôi',
	support_records_desc: 'Kiểm tra tiến độ và bổ sung thông tin.',
	support_refresh: 'Làm mới',
	support_tabs_label: 'Tab hỗ trợ',
	support_load_more: 'Tải thêm',
	support_user_id: 'ID người dùng',
	support_game: 'Trò chơi',
	support_platform: 'Nền tảng',
	support_back: 'Quay lại',
	support_mark_solved: 'Đã giải quyết',
	support_official_support: 'Hỗ trợ chính thức',
	support_image: 'Hình ảnh',
	support_reply_hint: 'Thông tin bổ sung của bạn sẽ được gửi tới hỗ trợ',
	support_send: 'Gửi',
	support_sending: 'Đang gửi...',
	support_player: 'Người chơi',
	support_attachment_preview: 'Xem trước tệp đính kèm',
	support_remove_attachment: 'Xóa tệp đính kèm',
	support_attachment_fallback: 'Tệp đính kèm',
	support_survey_title: 'Khảo sát',
	support_survey_message: 'Vấn đề của bạn đã được giải quyết?',
	support_survey_close: 'Đóng',
	support_submit_success: 'Gửi thành công',
	support_submit_fail: 'Gửi thất bại',
	support_close_success: 'Đã đóng cuộc trò chuyện',
	support_close_fail: 'Đóng thất bại',
	support_rate_title: 'Vui lòng đánh giá dịch vụ lần này',
	support_input_placeholder: 'Vui lòng nhập nội dung...',
	support_image_pick_error: 'Không lấy được đường dẫn hình ảnh',
	support_send_fail: 'Gửi thất bại',
	support_evaluate_success: 'Đánh giá thành công',
	support_evaluate_fail: 'Đánh giá thất bại',
	support_status_unreplied: 'Chưa trả lời',
	support_status_replied: 'Đã trả lời',
	support_status_resolved: 'Đã giải quyết',
	support_status_pending_review: 'Chờ đánh giá',
	support_form_type_label: 'Loại vấn đề',
	support_form_type_placeholder: 'Vui lòng chọn loại vấn đề',
	support_form_desc_label: 'Mô tả vấn đề',
	support_form_desc_placeholder: 'Vui lòng mô tả chi tiết vấn đề...',
	support_form_upload_label: 'Tệp đính kèm',
	support_form_upload_click: 'Tải tệp lên',
	support_form_upload_tips: '(ảnh dưới 10MB, video dưới 50MB, tối đa 5 tệp)',
	support_form_submit: 'Gửi',
	support_form_image_too_big: 'Kích thước ảnh không được vượt quá 10MB',
	support_form_video_too_big: 'Kích thước video không được vượt quá 50MB',
	support_type_topup: 'Vấn đề nạp tiền',
	support_type_account: 'Vấn đề tài khoản',
	support_type_guide: 'Hướng dẫn chơi',
	support_type_suggestion: 'Góp ý',
	support_type_event: 'Vấn đề sự kiện',
	support_type_report: 'Báo cáo vi phạm',
	support_type_other: 'Khác',
	support_type_topup_hint: 'Chưa nhận nạp, sai số tiền',
	support_type_account_hint: 'Đăng nhập, khóa, liên kết',
	support_type_guide_hint: 'Lối chơi, nhiệm vụ, tiến độ',
	support_type_suggestion_hint: 'Phản hồi và góp ý',
	support_type_report_hint: 'Gian lận, xúc phạm, vi phạm',
	support_type_other_hint: 'Vấn đề chưa phân loại',
	support_type_topup_code: 'Pay',
	support_type_account_code: 'Acc',
	support_type_guide_code: 'Tip',
	support_type_suggestion_code: 'Idea',
	support_type_report_code: 'Rpt',
	support_type_other_code: 'Etc',
	support_submitting: 'Đang gửi...',
	rebate_limited_text: '🔥 Hoàn tiền {pct}% có hạn',
	rebate_percent_text: 'Hoàn tiền {pct}%',
	coupon_booster_label: 'Phiếu tăng hoàn tiền',
	coupon_expires_after: 'Hết hạn sau {time}',
	coupon_threshold_shortfall: 'Mua thêm {amount} để sử dụng',
	coupon_product_excluded: 'Không áp dụng cho sản phẩm này',
	coupon_channel_restricted: 'Chỉ áp dụng khi thanh toán qua {channels}',
	coupon_unavailable_title: 'Phiếu không khả dụng',
	coupon_skip_text: 'Không dùng phiếu',
	coupon_count_unit: '',
	coupon_picker_title: 'Chọn phiếu giảm giá',
	coupon_entry_label: 'Phiếu ưu đãi',
	coupon_available_count: 'Có {count} phiếu',
	coupon_no_use_text: 'Không dùng phiếu',
	coupon_best_tag: 'Tốt nhất',
	coupon_expired_text: 'Đã hết hạn',
	close_text: 'Đóng',
	discount_coupon_label: 'Phiếu giảm giá',
	coupon_single_use_hint: 'Mỗi đơn hàng chỉ được dùng một phiếu',
	order_amount_text: 'Giá sản phẩm',
	discount_amount_text: 'Giảm giá',
	payable_amount_text: 'Tổng thanh toán',
	coupon_extra_rebate_notice: 'Phần hoàn thêm 50% sẽ được gửi qua thư. Vui lòng liên hệ hỗ trợ để đăng ký.',
	payment_recommended_text: 'Thanh toán đề xuất',
	payment_enjoy_rebate: 'Hoàn tiền {pct}%',
	payment_order_rebate: 'Hoàn tiền đơn này {amount}',
	payment_order_discount: 'Giảm giá đơn này {amount}',
	recommend_text: 'Đề xuất',
	payment_other_methods_text: 'Phương thức khác',
	super_coupon_title: 'Gói siêu ưu đãi có hạn',
	super_coupon_end_time: 'Sự kiện kết thúc lúc:',
	super_coupon_previous_activity: 'Ưu đãi trước',
	super_coupon_recommended: 'Đề xuất',
	super_coupon_view_details: 'Xem chi tiết gói ưu đãi',
	super_coupon_value_label: 'Tổng giá trị giảm giá',
	super_coupon_contents: 'Nội dung gói ưu đãi',
	super_coupon_threshold: 'Đơn từ {amount}',
	super_coupon_discount: 'Giảm {amount}',
	super_coupon_remaining: 'Còn {time}',
	super_coupon_purchased: 'Đã mua',
	super_coupon_buy_now: 'Mua ngay',
	super_coupon_next_activity: 'Ưu đãi tiếp theo',
	super_coupon_switcher: 'Chuyển ưu đãi',
	super_coupon_switch_to: 'Chuyển đến ưu đãi số {index}',
	super_coupon_details_title: 'Chi tiết gói ưu đãi',
	super_coupon_close_details: 'Đóng chi tiết gói ưu đãi',
	super_coupon_empty: 'Hiện không có phiếu giảm giá',
	super_coupon_instructions: 'Hướng dẫn sử dụng',
	super_coupon_confirm: 'Đã hiểu',
	super_coupon_package_name: 'Gói siêu ưu đãi',
	super_coupon_get_coupons: 'Nhận ngay {count} phiếu giảm giá khi mua',
	super_coupon_reward_multiple: 'Giá trị ưu đãi khoảng {multiple} lần',
	super_coupon_purchase_limit: 'Giới hạn {count} gói mỗi lần mua',
	super_coupon_purchase_interval: 'Khoảng cách giữa các lần mua: {days} ngày',
	super_coupon_rule_separator: ', ',
	super_coupon_unknown_status: 'Không rõ trạng thái',
	super_coupon_date_format: '{day}/{month}/{year} {time}',
	super_coupon_used: 'Đã sử dụng',
	super_coupon_expired: 'Đã hết hạn',
	super_coupon_unit_day: 'ngày',
	super_coupon_unit_days: 'ngày',
	super_coupon_unit_hour: 'giờ',
	super_coupon_unit_hours: 'giờ',
	super_coupon_unit_minute: 'phút',
	super_coupon_unit_minutes: 'phút',
	super_coupon_valid_for: 'Có hiệu lực trong {value} {unit}'
}
